import { useAuth0 } from '@auth0/auth0-react';
import { Popover } from 'antd';
import { FC, ReactElement } from 'react';
import { FeatureFlag } from './types/userType';

export const WithFeatureFlagsCheck: FC<{ ff: FeatureFlag; children: ReactElement<any, any> | null }> = ({ ff, children }) => {
  const { user } = useAuth0();

  if (!user || user === null) return null;

  var featureFlagEnabled: boolean = false;
  var roleAryballe: boolean = false;
  if (user.feature_flags.includes(FeatureFlag.RoleAryballe)) roleAryballe = true;

  if (user.feature_flags.includes(ff)) featureFlagEnabled = true;

  if (!featureFlagEnabled && !roleAryballe) return null;

  return (
    <div style={{ display: 'flex' }}>
      <>
        <div style={{ flex: 1 }}> {children} </div>
        {roleAryballe && (
          <Popover
            overlayStyle={{ zIndex: '1051' }}
            content={
              <>
                This feature is only available to users
                <br /> with feature_flag <b>"{ff}"</b> activated
              </>
            }
          >
            <span style={{ fontSize: '14pt', color: 'red', marginLeft: '5px', cursor: 'help' }}>*</span>
          </Popover>
        )}
      </>
    </div>
  );
};
